import { Component, OnInit } from '@angular/core';
import { LoaderService } from './loader.service';
import { Spinkit } from '../theme/shared/components/spinner/spinkits';

@Component({
  standalone: false,
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: [
    '../theme/shared/components/spinner/spinner.component.scss',
    '../theme/shared/components/spinner/spinkit-css/sk-line-material.scss'
  ],
})
export class LoaderComponent implements OnInit {

  // start: spinner
  public Spinkit = Spinkit;
  public spinner = Spinkit.skLine;
  public backgroundColor = '#2196f3';
  // end: spinner

  loading!: boolean;

  constructor(private loaderService: LoaderService) {
    this.loaderService.isLoading.subscribe((v) => {
      //console.log(v);
      this.loading = v;
    });
  }

  ngOnInit() {
  }

}
